import { HStack } from '@genial/components';
import React from 'react';

import { ProductTransactionFlow } from '../../../../store/transactionFlow/types';
import { CurrentAccountTable } from '../AssetTable/CurrentAccount';
import { FixedIncomeTable } from '../AssetTable/FixedIncome';
import { FundsTable } from '../AssetTable/Funds';
import { PublicOfferTable } from '../AssetTable/PublicOffer';
import { RequiredMarginTable } from '../AssetTable/RequiredMargin';
import { TreasuryTable } from '../AssetTable/Treasury';
import { VariableIncomeTable } from '../AssetTable/VariableIncome';

export interface DynamicAssetTableProps {
  product: ProductTransactionFlow;
  productData: any;
  onSelectClient: (cpfCnpj: string) => void;
}

export const DynamicAssetTable: React.FC<DynamicAssetTableProps> = ({ ...props }) => {
  const renderTableByProductType = () => {
    switch (props.product.key) {
      case 'funds':
        return <FundsTable {...props} />;
      case 'fixedIncome':
        return <FixedIncomeTable {...props} />;

      case 'variableIncome':
        return <VariableIncomeTable {...props} />;

      case 'treasury':
        return <TreasuryTable {...props} />;

      case 'publicOffer':
        return <PublicOfferTable {...props} />;

      case 'currentAccount':
        return <CurrentAccountTable {...props} />;

      case 'requiredMargin':
        return <RequiredMarginTable {...props} />;

      default:
        return <HStack />;
    }
  };

  return renderTableByProductType();
};
